<template>
    <div class="container py-5">
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-6 mx-auto">
                        <div class="card rounded-0">
                            <div class="card-header">
                                <h3 class="mb-0">{{ $t('login.login') }}</h3>
                            </div>
                            <div class="card-body">
                                <form v-on:submit="login" class="form" role="form" autocomplete="off" id="formLogin" novalidate="">
                                    <div class="form-group">
                                        <label for="uname1">{{ $t('login.username') }}</label>
                                        <input type="text" class="form-control form-control-lg rounded-0" v-model="username" id="uname1" required="" autocapitalize="none">
                                        <div class="invalid-feedback">{{ $t('login.usernameinvalid') }}</div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{ $t('login.password') }}</label>
                                        <input type="password" class="form-control form-control-lg rounded-0" v-model="password" id="pwd1" required="" autocomplete="new-password">
                                        <div class="invalid-feedback">{{ $t('login.passwordinvalid') }}</div>
                                    </div>
                                    <p class="text-right text-danger">{{ message }}</p>
                                    <button type="submit" class="btn btn-dark btn-lg float-right" id="btnLogin">{{ $t('login.login') }}</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'login',
    data: function () {
        return {
            username: '',
            password: '',
            message: '',
        };
    },
    computed: {
        user() {
            return this.$store.state.user;
        }
    },
    methods: {
        login: function (e) {
            e.preventDefault();
            this.message = '';

            this.$http.post('/api/user/login', { username: this.username, password: this.password }).then(() => {
                this.user.loggedIn = true;
                this.user.username = this.username;
                this.$router.push(this.$route.query.page || '/');
            }).catch(err => {
                const status = err.status;
                if (status === 401) this.message = this.$t('login.failed');
                else this.message = this.$t('internalerror');
            });
        },
    },
    components: {},
};
</script>